<!--
 * @Description:
 * @Author: PF
 * @Date: 2023-04-23 09:20:16
 * @LastEditors: PF
 * @LastEditTime: 2023-12-20 14:18:40
-->
<template>
  <vue-ueditor-wrap v-model="msg" :config="editorConfig"></vue-ueditor-wrap>
</template>

<script setup>
import { ref, watch, defineEmits } from 'vue'
const props = defineProps({
  value: {
    type: String,
    default: () => {
      return ''
    }
  },
  row: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const msg = ref(props.value)
const editorConfig = ref({
  readonly: false, // 编辑器初始化结束后,编辑区域是否是只读的，默认是false
  // 编辑器不自动被内容撑高
  autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: props.row.height || '100%',
  // 初始容器宽度
  initialFrameWidth: '100%',
  fullscreen: false, // 是否开启初始化时即全屏，默认关闭
  // 启用自动保存
  enableAutoSave: false,
  // 自动保存间隔时间， 单位ms
  saveInterval: 0,
  // 服务器地址
  serverUrl: process.env.VUE_APP_BASE_API + '/api/v2/sys/wenjian/ueditor?fwjjmc=public&wjjmc=fuwenben',
  // 上传图片地址
  uploadUrl: process.env.VUE_APP_BASE_API + '/api/v2/sys/wenjian/upload',
  imageUrlPrefix: process.env.VUE_APP_BASE_API,
  // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况
  UEDITOR_HOME_URL: '/ueditor/',
  toolbars: [[
    '', 'source', '|',
    'undo', 'redo', '|',
    'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'blockquote', 'pasteplain', '|',
    'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
    'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
    'directionalityltr', 'directionalityrtl', 'indent', '|',
    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
    'touppercase', 'tolowercase', '|',
    'link', 'unlink', 'anchor', '|',
    'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
    'simpleupload', 'insertimage', 'emotion', 'insertvideo', 'attachment', 'map', 'insertcode', 'template', '|',
    'horizontal', 'date', 'time', 'spechars', '|',
    // 'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
    'print', 'preview', 'searchreplace', 'help'
  ]]
})
// 监听外部传递进来的的数据变化
const emits = defineEmits(['update:value', 'ReturnData'])
watch(
  () => props.row,
  () => {
    if (props.row) {
      // editorConfig.value.initialFrameHeight = props.row.height || '100%'
      editorConfig.value.readonly = props.row.disabled
    }
  }
)
watch(
  () => props.value,
  () => {
    msg.value = props.value
    emits('update:value', msg.value)
  }
)
// 监听富文本中的数据变化
watch(
  () => msg.value,
  () => {
    emits('update:value', msg.value)
  }
)
</script>

<style lang="scss" scoped>
</style>
